import { createReducer } from 'util/reducers';

export interface ShortLinkMapState {
  [id: string]: string;
}

const initialState: ShortLinkMapState = {};

export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/shortLinkMap.ts